import { Box, Fade, Skeleton, styled } from '@mui/material';

import type { ContextualHelpMvpProps } from '..';

type ContextualHelpBodyProps = Pick<ContextualHelpMvpProps, 'helpContent'>;

const ResultSkeleton = styled(Skeleton)({ height: 20 });
const BreakSkeleton = styled(ResultSkeleton)({ marginBottom: 8 });

export function ContextualHelpBody({ helpContent }: ContextualHelpBodyProps) {
  return (
    <Box sx={{ pb: 3, mb: 'auto', mt: 4, overflowY: 'auto', width: '100%', height: '100%' }}>
      {helpContent ? (
        <Fade in timeout={800}>
          <Box sx={{ height: 'inherit' }}>{helpContent}</Box>
        </Fade>
      ) : (
        <div>
          <Skeleton sx={{ height: 36, mb: 2 }} />
          <ResultSkeleton />
          <BreakSkeleton />
          <ResultSkeleton />
          <ResultSkeleton />
          <BreakSkeleton />
          <ResultSkeleton />
          <BreakSkeleton />
          <ResultSkeleton />
          <ResultSkeleton />
          <BreakSkeleton />
          <ResultSkeleton />
          <ResultSkeleton />
        </div>
      )}
    </Box>
  );
}
